<header
  class="dashboard-header d-flex align-items-center justify-content-between gap-2 position-sticky top-0 py-2 px-3 px-md-4 z-3 dashboard-header-border"
>

  <!-- LEFT: Hamburger (mobile) + Breadcrumb -->
  <div class="d-flex align-items-center gap-2 gap-md-3 min-w-0">

    <!-- 🍔 MOBILE SIDEBAR TOGGLE -->
    <button
      v-if="is_mobile"
      class="btn btn-sm btn-outline-primary rounded-circle d-flex align-items-center justify-content-center"
      @click="$emit('toggle-mobile-sidebar')"
    >
      <i class="bi bi-list"></i>
    </button>

    <!-- Breadcrumb -->
    <div class="breadcrumb d-flex align-items-center flex-wrap mb-0">

      <template v-if="breadcrumb && breadcrumb.length">
        <span
          v-for="(crumb, i) in breadcrumb"
          :key="crumb.id + '-' + i"
          class="d-flex align-items-center "
        >
          <a
            v-if="i < breadcrumb.length - 1"
            href="#"
            @click.prevent="$emit('breadcrumb-click', crumb.id)"
            class="text-header-dark text-decoration-none "
          >
            {{ crumb.title }}
          </a>

          <span
            v-else
            class="text-header-dark fw-semibold "
          >
            {{ crumb.title }}
          </span>

          <span v-if="i < breadcrumb.length - 1" class="text-header-dark mx-1">/</span>
        </span>
      </template>

      <span v-else class="text-header-dark fw-semibold ">
        Dashboard
      </span>

    </div>
  </div>

  <!-- RIGHT: Actions -->
  <ul class="navbar-nav flex-row align-items-center gap-2 gap-md-3 flex-shrink-0">

    <!-- 🤖 NPI Assistant (DESKTOP ONLY) -->
    <li class="nav-item">
      <BolideAssistantButton @open-assistant="openAssistant" />
    </li>

    <!-- User Management -->
    <li class="nav-item">
      <router-link to="/user_management" class="nav-link text-header-dark p-0">
        <i class="bi bi-person-gear fs-6"></i>
      </router-link>
    </li>

    <!-- Logout -->
    <li class="nav-item">
      <a
        href="#"
        class="nav-link text-header-dark p-0"
        @click.prevent="logoutUser"
      >
        <i class="bi bi-box-arrow-right fs-6"></i>
      </a>
    </li>

  </ul>

</header>
